module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Escales","direct":"Direct","one-stopover":"Une escale ou moins","many-stopover":"Indifférent"},"en":{"title":"Stops","direct":"No stops","one-stopover":"One stop or less","many-stopover":"Any number of stops"}}')
  delete Component.options._Ctor
}
